// Global
import { jsx as _jsx } from "react/jsx-runtime";
import graphqlClientFactory from 'lib/graphql-client-factory';
import ServicePageQuery from './ServicePage.graphql';
import ExpertCardContentBlockClient from './ExpertCardContentBlockClient';
/**
 * Server entry point (App Router). Mirrors the project pattern used by
 * `Breadcrumb` / `ContextualNav` / `LocationsBlock`: this file stays a Server
 * Component so the SDK can call `getComponentServerProps` server-side, and all
 * interactive logic (React hooks, editing helpers, dictionary lookups) lives
 * in the dedicated `ExpertCardContentBlockClient.tsx`.
 *
 * Adding `'use client'` here would convert the whole module into a Client
 * Reference, after which the SDK would throw at runtime:
 *   "Attempted to call getComponentServerProps() from the server but
 *    getComponentServerProps is on the client."
 * Webpack's `component-props.loader` masks the issue in production builds but
 * Turbopack (the Next.js 16 dev server default) does not run that loader.
 */ export const Default = (props)=>/*#__PURE__*/ _jsx(ExpertCardContentBlockClient, {
        ...props
    });
